import { pathOr, sortBy } from 'ramda';

import {
  Button,
  Box,
  CheckboxGroup,
  Checkbox,
  FormControl,
  FormLabel,
} from '@frontend/legacy-components';

const SeeMoreButton = ({ children, ...rest }) => (
  <Button variant="link" size="sm" {...rest}>
    {children}
  </Button>
);

const ExpandableFilterList = ({
  agg,
  label,
  onClick,
  onSeeMore,
  selectedKeys,
}) => {
  if (!agg?.buckets || agg.buckets.length === 0) {
    return null;
  }
  const sortByKey = sortBy((x) => x.toLowerCase());
  //it's possible to have previous selected features which are no longe valid
  const mappedDeduplicatedBucket = agg.buckets
    .map((bucketItem) => bucketItem.key)
    .filter((bucketKey) => selectedKeys.indexOf(bucketKey) < 0);
  const displayValues = selectedKeys.concat(mappedDeduplicatedBucket);
  const sortedDisplayValues = sortByKey(displayValues);
  return (
    <Box mb={2}>
      <FormControl>
        <FormLabel>{label}</FormLabel>
        <CheckboxGroup direction="column">
          {sortedDisplayValues.map((key) => (
            <Checkbox
              isChecked={selectedKeys.includes(key)}
              onChange={() => onClick(key)}
              key={key}
            >
              {key}
            </Checkbox>
          ))}
        </CheckboxGroup>
        {pathOr(0, ['sumOtherDocCount'], agg) > 0 && (
          <SeeMoreButton marginLeft={3} onClick={onSeeMore}>
            See more
          </SeeMoreButton>
        )}
      </FormControl>
    </Box>
  );
};

export default ExpandableFilterList;
